"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.finleyBufferToCsvArray = exports.smallCsvParser = exports.defaultParseConfig = void 0;
const Papa = __importStar(require("papaparse"));
const stripCarriageReturn = (str) => str.charAt(str.length - 1) === '\r' ? str.slice(0, str.length - 1) : str;
const defaultNewLine = '\n';
// Configuration options that are not meant to be overridden by external callers
exports.defaultParseConfig = {
    // Papaparse's automatic line-ending detection does not robustly handle files that use line
    // endings inconsistently. We force it to treat \n as the newline character. This may leave an
    // extra \r in the last column of every line, which we then need to strip out.
    newline: defaultNewLine,
    header: false, // DO NOT USE `header: true` (see COMMON_SUFFIX tests for explanation, Papa parse does not handle headers with common suffixes in each header, Papa parse can still parse the full set of data to output an array of string arrays that represents the body of the csv, but each row/column must be added individually according to the expected header prior to using within Finley systems)
    transform: stripCarriageReturn,
    transformHeader: stripCarriageReturn,
    quoteChar: '"',
    escapeChar: '"',
    skipEmptyLines: true,
};
/**
 * Handles regular CSV parsing by converting buffer to string.
 * Suitable for small to medium files. Will not work on large 500MB+ files due
 * node string size constraints.
 * For large files (when using from node.js) use common-backend/finleyBuffer.largeCsvParser
 */
const smallCsvParser = async ({ buffer, parseConfig, rowHandler, errorHandler, }) => {
    const decoder = new TextDecoder('utf-8');
    const csvString = decoder.decode(buffer);
    Papa.parse(csvString, {
        ...parseConfig,
        step: (results) => {
            rowHandler(results.data);
            results.errors.forEach(errorHandler);
        },
    });
};
exports.smallCsvParser = smallCsvParser;
/**
 * Assumptions:
 * 1) Papa parse does not handle header parsing consistently. Always handle it ourselves.
 * 2) Header option will always be set to true in our system even though it is false by default for Papa Parse. Finley usage is expected to be a formatted CSV object (string[] output can be implemented separately), but not necessarily with expectation of being sanitized.
 * 3) Dynamic typing is not required by default and is handled by our sanitizer logic rather than Papa parse configuration
 * 4) Specific character sets can be removed if specified through the regex option. This may need to be a general default but isolated for use in only some cases at the moment.
 */
const finleyBufferToCsvArray = async ({ buffer, delimiter = ',', dynamicTyping = false, headerRenameFunction, csvParser, }) => {
    // ----- CSV PARSING -----
    const output = {
        originalHeaders: [],
        csvArray: [],
        errors: [], // Currently unused, and also not reliable (see usage below).
    };
    // Override default parser configurations
    const parseConfig = {
        ...exports.defaultParseConfig,
        delimiter,
        dynamicTyping,
    };
    let headerRow;
    const rowHandler = (row) => {
        if (!headerRow) {
            headerRow = headerRenameFunction
                ? row.map(headerRenameFunction)
                : [...row];
            output.originalHeaders = headerRow;
            return;
        }
        const convertedRow = {};
        headerRow.forEach((header, columnIdx) => {
            convertedRow[header] = row[columnIdx];
        });
        output.csvArray.push(convertedRow);
    };
    const errorHandler = (error) => output.errors.push(error);
    // Use custom parser if provided
    await csvParser({
        buffer,
        parseConfig,
        rowHandler,
        errorHandler,
    });
    return output;
};
exports.finleyBufferToCsvArray = finleyBufferToCsvArray;
//# sourceMappingURL=buffer.js.map